// Тексты личных настроек: язык, тема, отображение (PREF-UC-1…3).
export const ru = {
  preferences: {
    title: 'Оформление и язык',
    personal: {
      title: 'Отображение',
      subtitle: 'Только для вас — на всех ваших вкладках и устройствах. Остальные пользователи видят значения платформы.',
      platform: 'На платформе: {value}',
      own: 'Своё значение',
      edit: 'Изменить',
      reset: 'Как на платформе',
      invalid: 'Своё значение {value} больше недопустимо и не применяется — действует значение платформы.',
      notSaved: 'Не сохранено',
      empty: 'Личных настроек нет',
    },
    language: 'Язык',
    theme: 'Тема',
    mode: 'Режим',
    themes: {
      frog: 'Розовая лягушка',
      journal: 'Гастрожурнал',
      craft: 'Крафт',
      kitchen: 'Чистая кухня',
    },
    themeHints: {
      frog: 'Цвета логотипа: дерево, розовый, терракота',
      journal: 'Редакционная: чёрное, белое, красный',
      craft: 'Пастель: овёс, шалфей, абрикос',
      kitchen: 'Пастель: мята, лаванда',
    },
    modes: {
      light: 'Светлый',
      dark: 'Тёмный',
      system: 'Как в системе',
    },
    pastel: 'пастель',
  },
};

export const en: typeof ru = {
  preferences: {
    title: 'Appearance and language',
    personal: {
      title: 'Display',
      subtitle: 'Just for you — in all your tabs and devices. Other users see the platform values.',
      platform: 'Platform: {value}',
      own: 'Your value',
      edit: 'Change',
      reset: 'Same as platform',
      invalid: 'Your value {value} is no longer allowed and is not applied — the platform value is used.',
      notSaved: 'Not saved',
      empty: 'No personal settings',
    },
    language: 'Language',
    theme: 'Theme',
    mode: 'Mode',
    themes: {
      frog: 'Pink frog',
      journal: 'Food journal',
      craft: 'Craft',
      kitchen: 'Clean kitchen',
    },
    themeHints: {
      frog: 'Logo colors: wood, pink, terracotta',
      journal: 'Editorial: black, white, red',
      craft: 'Pastel: oat, sage, apricot',
      kitchen: 'Pastel: mint, lavender',
    },
    modes: {
      light: 'Light',
      dark: 'Dark',
      system: 'System',
    },
    pastel: 'pastel',
  },
};
